import { isLoadsListPath } from '@/app/@protected/loads/_utils/loads-paths.ts'

/**
 * The Duplicates created in this browser tab, held in memory only, so a reload forgets them.
 * `listedLoadIds` holds the Duplicates the loads list highlights until the User leaves the list.
 */
export type DuplicateRecord = {
  listedLoadIds: ReadonlySet<number>
}

export const EMPTY_DUPLICATE_RECORD: DuplicateRecord = {
  listedLoadIds: new Set(),
}

export const recordDuplicate = (record: DuplicateRecord, loadId: number): DuplicateRecord => ({
  listedLoadIds: new Set(record.listedLoadIds).add(loadId),
})

// Leaving the loads list ends its highlights; moving between its tabs or Saved Views keeps them.
export const leavePath = (record: DuplicateRecord, from: string, to: string): DuplicateRecord => ({
  listedLoadIds: isLoadsListPath(from) && !isLoadsListPath(to) ? new Set() : record.listedLoadIds,
})
